const getters = {
    check: (state) => {
        return !!state.user;
    },
    name: (state) => {
        return state.user ? state.user.name : ''
    },
    user_code: (state) => {
        return state.user ? state.user.user_code : ''
    },
    company_code: (state) => {
        return state.user ? state.user.company_code : ''
    },
    company_name: (state) => {
        return state.user ? state.user.company_name : ''
    },
    user_edit_role: (state) => {
        return state.user ? state.user.user_edit_role : ''
    },
    store_assign_role: (state) => {
        return state.user ? state.user.store_assign_role : ''
    },
    is_agreement_setting: (state) => {
        return state.user ? state.user.is_agreement_setting : ''
    },
    token: (state) => {
        return state.token ? state.token : ''
    },
};

export default getters;